import HTTP from '../HTTP';

const PARAMETRAGE_URL = 'parametrages/';

export default async function PGetAllSecteurActiviteAsync() {
  // eslint-disable-next-line no-useless-catch
  try {
    const query = {
      query: {},
      sorting: 'libelle ASC',
      skipCount: 0,
      maxResultCount: 99999,
    };
    const response = await HTTP.post(`${PARAMETRAGE_URL}/PGetAllSecteurActiviteAsync`, query);
    return response;
  } catch (e) {
    throw e;
  }
}